"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingSignerException = exports.NumberOfSignersAndSignaturesException = exports.AlreadySignedTransactionException = exports.MissingGtxException = exports.UnexpectedArgumentTypeError = void 0;
const customError_1 = require("../customError");
class UnexpectedArgumentTypeError extends customError_1.CustomError {
    constructor(typedArg) {
        super(`Cannot parse typedArg ${JSON.stringify(typedArg)}. Unknown type ${typedArg.type}`, 400);
    }
}
exports.UnexpectedArgumentTypeError = UnexpectedArgumentTypeError;
class MissingGtxException extends customError_1.CustomError {
    constructor() {
        super(`Missing instance of gtx protocol (used for communicating with postchain) to add operation to`, 400);
    }
}
exports.MissingGtxException = MissingGtxException;
class AlreadySignedTransactionException extends customError_1.CustomError {
    constructor(operation) {
        super(`Cannot add ${operation} calls to an already signed gtx`, 400);
    }
}
exports.AlreadySignedTransactionException = AlreadySignedTransactionException;
class NumberOfSignersAndSignaturesException extends customError_1.CustomError {
    constructor() {
        super(`Not matching number of signers and signatures`, 400);
    }
}
exports.NumberOfSignersAndSignaturesException = NumberOfSignersAndSignaturesException;
class MissingSignerException extends customError_1.CustomError {
    constructor() {
        super(`No such signer, remember to add signer to transaction before adding a signature`, 400);
    }
}
exports.MissingSignerException = MissingSignerException;
//# sourceMappingURL=errors.js.map